<template>
  <div class="download-cont">
    <div class="title">在线听课只需 <span class="num">2</span> 步</div>
    <div class="download-list">
      <div class="download-item">
        <img
          class="step-num"
          src="../../../../assets/images/learning-center/step1.png"
          alt="1"
        />
        <div class="step-info">
          <div class="info-top">
            <span class="step-text">下载客户端</span>
            <button @click="jumpDownload" class="download-btn">立即下载</button>
          </div>
          <p class="tips">购课后及时下载客户端，观看直播更加流程</p>
        </div>
      </div>
      <div class="download-item step2">
        <img
          class="step-num"
          src="../../../../assets/images/learning-center/step2.png"
          alt="2"
        />
        <div class="step-info">
          <p class="step-text">上课</p>
          <p class="tips">登录客户端后，进行上课即可</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jumpDownload() {
      this.$router.push({
        path: "/download",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.download-cont {
  font-family: PingFangSC;
  height: 207px;
  background: #ffffff;
  border-radius: 18px;
  margin-top: 16px;
  padding: 16px 18px;
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #0d1400;
    line-height: 25px;
    margin-bottom: 20px;
    .num {
      font-weight: 500;
      font-size: 20px;
      line-height: 25px;
      color: #00c89d;
    }
  }
  .download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 74px;
    height: 24px;
    background: linear-gradient(116deg, #b7ff5e 0%, #6dffe8 100%);
    border-radius: 15px;
    font-weight: 500;
    font-size: 14px;
    color: #0d1400;
    line-height: 18px;
    margin-left: 9px;
  }
  .step2 {
    margin-top: 26px;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      display: block;
      width: 2px;
      height: 23px;
      border: 1px dashed #c9cdd4;
      left: 10px;
      top: -25px;
    }
  }
  .download-item {
    display: flex;
    align-items: center;
    .step-num {
      width: 20px;
      margin-right: 23px;
    }
    .info-top {
      display: flex;
      align-items: center;
    }

    .step-text {
      font-weight: 500;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      margin-bottom: 2;
    }
    .tips {
      font-weight: 400;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
    }
  }
}
</style>
